module.exports = __webpack_public_path__ + "img/수업이끝나면3.accebb9d.gif";